import {z} from '@hono/zod-openapi';

import {AutoplacPlFeedTenantParamsSchema} from './AutoplacPlFeedTenantParamsSchema';

export const AutoplacPlFeedBranchParamsSchema = AutoplacPlFeedTenantParamsSchema.extend({
  branchId: z.string().uuid(),
}).openapi('AutoplacPlFeedBranchParams');
